import { Job } from "src/models/job";
import { createEntityModel } from "src/store/models/entity/_shared";

export const JobEntityModel = createEntityModel<Job>();
